import { useEffect } from 'react';

type TUnsubscribe = () => void;

type TSubscribe = () => TUnsubscribe | undefined;

const useSubscription = (subscribe: TSubscribe, deps: readonly unknown[]): void => {
  useEffect(() => {
    const unsubscribe = subscribe();

    return () => {
      unsubscribe?.();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export type {
  TSubscribe,
  TUnsubscribe,
};
export {
  useSubscription,
};
